import React from "react";

import { Box, IconButton, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import MUIIcon from "../ui/MUIIcon";

const ToolbarItem = ({ name, label, iconName, onClick, hide }) => {
  const { getLabel } = useLocalization();

  if (hide) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
    >
      <IconButton
        color="black"
        sx={{ padding: "0px" }}
      >
        <MUIIcon
          name={iconName}
          onClick={() => onClick(name)}
        />
      </IconButton>
      <Typography
        color="black"
        variant="overline"
        padding={0}
        lineHeight={1}
        fontSize="0.5rem"
      >
        {getLabel(label || name)}
      </Typography>
    </Box>
  );
};

export default ToolbarItem;
